module.exports = __webpack_public_path__ + "build/img/hands.7b5dda0e.png";